<template>
  <div class="lp-block7 lp-block">
    <p class="infotitle-min">生年月日と名前で占う「鳳凰数術」</p>
    <p class="infotitle">YouTubeで解説中！</p>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, idx) of youtubeList" :key="idx">
        <div class="box">
          <a :href="`${item.linkurl}`" target="_blank"><img :src="`/static/img/mark_lp/kurenotori/${item.imgsrc}.png`" alt=""></a>
        </div>
      </swiper-slide>
    </swiper>
    <a class="linebanner" href="/lp/campaign/1"><img src="/static/img/recommend/lp/banner/kurenotori_line_20220316.png" alt=""></a>
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'TempBlock7',
  components: {
    swiper,
    swiperSlide
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 1.2,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          // disableOnInteraction: false,
        },
        loop: true,
        loopAdditionalSlides: 1,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      youtubeList: [
        {
          imgsrc: 'youtubethum_1',
          linkurl: 'https://youtu.be/JxC3ia9LnF8'
        },
        {
          imgsrc: 'youtubethum_2',
          linkurl: 'https://youtu.be/xsvl89N1WxQ'
        },
        {
          imgsrc: 'youtubethum_3',
          linkurl: 'https://youtu.be/UnlN-MC47sI'
        }
      ]
    }
  }
}</script>

<style scoped lang='scss'>
.lp-block7 {
  background: #fff;
}

.linebanner img {
  width: 80%;
  padding: 64px 0;
}

.box {
  padding: 0 10px;
  img {
    //width: 267px;
    width: 100%;
  }
}

.infotitle-min {
  font-size: 14px;
  color: #000;
  margin: 0;
  margin-top: 24px;
}

.infotitle {
  font-size: 19px;
  color: #000;
  margin: 1px;
  margin-bottom: 30px;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/MarkLp/Kurenotori/Lp1/LpBlock7.vue